import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Wrapper, ContentBoard, RightSide } from '../styledComponents';
import { ControlBarContext } from '../../ControlBarContext';
import doFetch from '../../../api/doFetch';
import LogsTable from './LogsTable';
import Provider from './context';
import Filter from './Filter';

export const defaultValue = { period: 'day', dealers: [], channel: null, status: null, vin: null };

const LotlenzPartnerLogsPage = ({ getBreadCrumbs }) => {
  const { setBreadCrumbs } = useContext(ControlBarContext);
  const { partnerId } = useParams();

  useEffect(() => {
    if (partnerId) {
      doFetch(`/lotlenz/partners/${partnerId}`).then((partner) => {
        setBreadCrumbs(getBreadCrumbs(partner));
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerId]);

  useEffect(() => {
    setBreadCrumbs(getBreadCrumbs());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Provider>
      <Wrapper>
        <div className='body'>
          <ContentBoard heightCorrection={88}>
            <LogsTable partnerId={partnerId} />
          </ContentBoard>
          <RightSide>
            <Filter />
          </RightSide>
        </div>
      </Wrapper>
    </Provider>
  );
};

export default LotlenzPartnerLogsPage;
